
define('ldsh!modules/includes_editor/templates/edit', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<textarea id="includeEditor" class="hidden"></textarea>\n\n<!-- checkbox to add the js in the head that should only appear in the add js popup (not css) -->\n';
 if(this.editorMode === "javascript") { ;
__p += '\n  <div class="ed-form-group code-options">\n    <div class="md__checkbox--wrapper mb16 pt16">\n      <input\n        id="scriptLocation"\n        name="hiddenDeliveries"\n        type="checkbox"\n        class="scriptLocation md__checkbox--primary"\n        ' +
((__t = ( this.model.get("head") === true ? "checked" : "" )) == null ? '' : __t) +
'\n      >\n      <label\n        for="scriptLocation"\n        class="gap-4 f14"\n        data-i18n="includeEditor.scriptLocation"\n      ></label>\n    </div>\n  </div>\n';
 } ;
__p += '\n';

}
return __p
};});

